import _toConsumableArray from "/Users/katnoria/dev/workspaces/web/katnoria.com/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import * as tslib_1 from "tslib";
import { selector as parseSelector } from 'vega-event-selector';
import { identity, isArray, stringValue } from 'vega-util';
import { forEachSelection, MODIFY, SELECTION_DOMAIN, STORE, unitName, VL_SELECTION_RESOLVE } from '.';
import { dateTimeExpr, isDateTime } from '../../datetime';
import { warn } from '../../log';
import { accessPathWithDatum, keys, logicalExpr, varName } from '../../util';
import { isUnitModel } from '../model';
import { forEachTransform } from './transforms/transforms';
export function assembleInit(init) {
  var wrap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : identity;

  if (isArray(init)) {
    var str = init.map(function (v) {
      return assembleInit(v, wrap);
    }).join(', ');
    return "[".concat(str, "]");
  } else if (isDateTime(init)) {
    return wrap(dateTimeExpr(init));
  }

  return wrap(JSON.stringify(init));
}
export function assembleInitData(init) {
  if (isArray(init)) {
    return init.map(function (v) {
      return assembleInitData(v);
    });
  } else if (isDateTime(init)) {
    return dateTimeExpr(init, false, true);
  }

  return init;
}
export function assembleUnitSelectionSignals(model, signals) {
  forEachSelection(model, function (selCmpt, selCompiler) {
    var _signals;

    var name = selCmpt.name;
    var modifyExpr = selCompiler.modifyExpr(model, selCmpt);

    (_signals = signals).push.apply(_signals, _toConsumableArray(selCompiler.signals(model, selCmpt)));

    forEachTransform(selCmpt, function (txCompiler) {
      if (txCompiler.signals) {
        signals = txCompiler.signals(model, selCmpt, signals);
      }

      if (txCompiler.modifyExpr) {
        modifyExpr = txCompiler.modifyExpr(model, selCmpt, modifyExpr);
      }
    });
    signals.push({
      name: name + MODIFY,
      update: "modify(".concat(stringValue(selCmpt.name + STORE), ", ").concat(modifyExpr, ")")
    });
  });
  return signals;
}
export function assembleFacetSignals(model, signals) {
  if (model.component.selection && keys(model.component.selection).length) {
    var name = stringValue(model.getName('cell'));
    signals.unshift({
      name: 'facet',
      value: {},
      on: [{
        events: parseSelector('mousemove', 'scope'),
        update: "isTuple(facet) ? facet : group(".concat(name, ").datum")
      }]
    });
  }

  return signals;
}
export function assembleTopLevelSignals(model, signals) {
  var hasSelections = false;
  forEachSelection(model, function (selCmpt, selCompiler) {
    var name = selCmpt.name;
    var store = stringValue(name + STORE);
    var hasSg = signals.filter(function (s) {
      return s.name === name;
    });

    if (!hasSg.length) {
      signals.push({
        name: selCmpt.name,
        update: "".concat(VL_SELECTION_RESOLVE, "(").concat(store) + (selCmpt.resolve === 'global' ? ')' : ", ".concat(stringValue(selCmpt.resolve), ")"))
      });
    }

    hasSelections = true;

    if (selCompiler.topLevelSignals) {
      signals = selCompiler.topLevelSignals(model, selCmpt, signals);
    }

    forEachTransform(selCmpt, function (txCompiler) {
      if (txCompiler.topLevelSignals) {
        signals = txCompiler.topLevelSignals(model, selCmpt, signals);
      }
    });
  });

  if (hasSelections) {
    var hasUnit = signals.filter(function (s) {
      return s.name === 'unit';
    });

    if (!hasUnit.length) {
      signals.unshift({
        name: 'unit',
        value: {},
        on: [{
          events: 'mousemove',
          update: 'isTuple(group()) ? group() : unit'
        }]
      });
    }
  }

  return signals;
}
export function assembleUnitSelectionData(model, data) {
  forEachSelection(model, function (selCmpt) {
    var init = {
      name: selCmpt.name + STORE
    };

    if (selCmpt.init) {
      var fields = selCmpt.project.items.map(function (proj) {
        var signals = proj.signals,
            rest = tslib_1.__rest(proj, ["signals"]);

        return rest;
      });
      var insert = selCmpt.init.map(function (i) {
        return assembleInitData(i);
      });
      init.values = selCmpt.type === 'interval' ? [{
        unit: unitName(model),
        fields: fields,
        values: insert
      }] : insert.map(function (i) {
        return {
          unit: unitName(model),
          fields: fields,
          values: i
        };
      });
    }

    var contains = data.filter(function (d) {
      return d.name === selCmpt.name + STORE;
    });

    if (!contains.length) {
      data.push(init);
    }
  });
  return data;
}
export function assembleUnitSelectionMarks(model, marks) {
  forEachSelection(model, function (selCmpt, selCompiler) {
    marks = selCompiler.marks ? selCompiler.marks(model, selCmpt, marks) : marks;
    forEachTransform(selCmpt, function (txCompiler) {
      if (txCompiler.marks) {
        marks = txCompiler.marks(model, selCmpt, marks);
      }
    });
  });
  return marks;
}
export function assembleLayerSelectionMarks(model, marks) {
  var _iterator = _createForOfIteratorHelper(model.children),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var child = _step.value;

      if (isUnitModel(child)) {
        marks = assembleUnitSelectionMarks(child, marks);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return marks;
}
export function assembleSelectionPredicate(model, selections, dfnode) {
  var stores = [];

  function expr(name) {
    var vname = varName(name);
    var selCmpt = model.getSelectionComponent(vname, name);
    var store = stringValue(vname + STORE);

    if (selCmpt.project.timeUnit) {
      var child = dfnode || model.component.data.raw;
      var tunode = selCmpt.project.timeUnit.clone();

      if (child.parent) {
        tunode.insertAsParentOf(child);
      } else {
        child.parent = tunode;
      }
    }

    if (selCmpt.empty !== 'none') {
      stores.push(store);
    }

    return "vlSelectionTest(".concat(store, ", datum") + (selCmpt.resolve === 'global' ? ')' : ", ".concat(stringValue(selCmpt.resolve), ")"));
  }

  var predicateStr = logicalExpr(selections, expr);
  return (stores.length ? '!(' + stores.map(function (s) {
    return "length(data(".concat(s, "))");
  }).join(' || ') + ') || ' : '') + "(".concat(predicateStr, ")");
} // Selections are parsed _after_ scales. If a scale domain is set to
// use a selection, the SELECTION_DOMAIN constant is used as the
// domainRaw.signal during scale.parse and then replaced with the necessary
// selection expression function during scale.assemble. To not pollute the
// type signatures to account for this setup, the selection domain definition
// is coerced to a string and appended to SELECTION_DOMAIN.

export function assembleSelectionScaleDomain(model, domainRaw) {
  var selDomain = JSON.parse(domainRaw.signal.replace(SELECTION_DOMAIN, ''));
  var name = varName(selDomain.selection);
  var encoding = selDomain.encoding;
  var field = selDomain.field;
  var selCmpt = model.component.selection && model.component.selection[name];

  if (selCmpt) {
    warn('Use "bind": "scales" to setup a binding for scales and selections within the same view.');
  } else {
    selCmpt = model.getSelectionComponent(name, selDomain.selection);

    if (!encoding && !field) {
      field = selCmpt.project.items[0].field;

      if (selCmpt.project.items.length > 1) {
        warn('A "field" or "encoding" must be specified when using a selection as a scale domain. ' + "Using \"field\": ".concat(stringValue(field), "."));
      }
    } else if (encoding && !field) {
      var encodings = selCmpt.project.items.filter(function (p) {
        return p.channel === encoding;
      });

      if (!encodings.length || encodings.length > 1) {
        field = selCmpt.project.items[0].field;
        warn((!encodings.length ? 'No ' : 'Multiple ') + "matching ".concat(stringValue(encoding), " encoding found for selection ").concat(stringValue(selDomain.selection), ". ") + "Using \"field\": ".concat(stringValue(field), "."));
      } else {
        field = encodings[0].field;
      }
    }

    return {
      signal: accessPathWithDatum(field, name)
    };
  }

  return {
    signal: 'null'
  };
}